module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Contents"
    }
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Table of Contents")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_AuthorNote#Author-Note"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("A Note from the Author")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Foreword#Foreword"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Foreword by Jean Kantambu Latting, DrPH, LMSW")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#Chapter01"
    }
  }, [_vm._v("Chapter 1 "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Where Do I Belong?")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02#Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2 "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Belonging and the Trauma-Informed State of the Workplace")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3 "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Workplace Bravery, and All the Stuff")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4 "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("We’re in It Together")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05#Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5 "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("It’s About the Managers")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter06#Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6 "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Getting Aligned on Workplace Belonging")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter07#Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7 "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("The Path Forward")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Appreciation#Appreciation",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("In Appreciation")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Questions#Questions",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Book Club Questions")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/19_AbouttheAuthor#About-the-Author"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Endnotes#Endnotes",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Endnotes")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "page-break-after": "always"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/p1.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d63faa3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Contents.vue
// module id = 75
// module chunks = 0